import { css } from 'styled-components';

export default css`
  .confetti-canvas {
    /* wunderkind pop-up has 2147483645 */
    z-index: 2147483646 !important;
  }
`;
